import React, { useMemo } from "react";

import { GoogleMap, useLoadScript, Marker } from "@react-google-maps/api";

const containerStyle = {
  width: "100%",
  height: "100%",
};

function Map({ myCoords, borderRadius }) {
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: "AIzaSyAWauq11iRRPxydTOEpQIklPosjWe7pfmY",
    libraries: ["places"],
  });

  const center = useMemo(
    () =>
      Object.keys(myCoords).length > 0
        ? myCoords
        : { lat: 32.715736, lng: -117.161087 },
    [myCoords]
  );

  if (loadError) {
    return <div>Map cannot be loaded right now, sorry.</div>;
  }
  return isLoaded ? (
    <GoogleMap
      mapContainerStyle={{ ...containerStyle, borderRadius: borderRadius }}
      center={center}
      zoom={12}
    >
      {Object.keys(myCoords).length > 0 && (
        <Marker key={myCoords?.id} position={myCoords}>
          <span>123123123123</span>
        </Marker>
      )}
    </GoogleMap>
  ) : (
    <></>
  );
}

export default Map;

// import React, {
//   useEffect,
//   useState,
//   useRef,
//   useMemo,
//   useCallback,
// } from "react";
// import L, { LatLngExpression, marker } from "leaflet";
// import "leaflet/dist/leaflet.css";
// import { imageUrl } from "../../Config/apiUrl";
// import { useHistory } from "react-router-dom";
// import { useSelector } from "react-redux";
// import { MapMarkerBlack, MapMarkerWhite } from "../../constant/imagePath";
// import classes from "./CustomMap.module.css";
// import Fonts from "../../stories/assets/Fonts";
// import Colors from "../../stories/assets/Colors";
// import { ArrowUpRightBlue } from "../../constant/imagePath";
// import { LinkButtonWithIcon } from "../../stories/LinkButtonWithIcon/LinkButtonWithIcon.jsx";
// import { GoogleMap, useJsApiLoader, Marker } from '@react-google-maps/api';
// import GoogleMapReact from "google-map-react";
// import { MapPin } from "../../stories/MapPin/MapPin";

// const containerStyle = {
//   width: '100%',
//   height: '100%'
// };

// function Map({ locations, myCoords, borderRadius }) {
//   const { isLoaded } = useJsApiLoader({
//     googleMapsApiKey: "AIzaSyAWauq11iRRPxydTOEpQIklPosjWe7pfmY",
//     libraries: ['places']
//   });
//   const center = useMemo(() => (
//     Object.keys(myCoords).length > 0
//       ? myCoords
//       : { lat: 32.715736, lng: -117.161087 }), [myCoords]);

//   return isLoaded ? (
//     <GoogleMap
//       mapContainerStyle={containerStyle}
//       center={center

//       }
//       zoom={12}
//     >
//       {Object.keys(myCoords).length > 0 && (
//         <Marker
//           key={myCoords?.id}
//           position={myCoords}
//         ><span>123123123123</span></Marker>
//       )}
//     </GoogleMap>
//   ) : <></>
// }

// export default Map;
